import { JSX } from "react";
import { useTranslation } from "react-i18next";

import TvCard from "@/components/cards/TvCard/TvCard.tsx";
import Carousel from "@/components/helpers/Carousel.tsx";
import Section from "@/components/helpers/Section/Section.tsx";

import { Broadcast } from "@/api/broadcast/broadcast.types.ts";
import { ROUTES } from "@/config/routes.ts";
import { useGetBroadcasts } from "@/hooks/api/broadcast.hooks.ts";

const MainTvSection = (): JSX.Element => {
  const { t } = useTranslation();
  const { data } = useGetBroadcasts();

  return (
    <Section title={t("General.tv-channels")} link={ROUTES.CHANNELS.MAIN} className={`group/section`}>
      <Carousel<Broadcast>
        swiperParams={{
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 16,
          breakpoints: {
            576: { slidesPerGroup: 4, slidesPerView: 4 },
            768: { slidesPerGroup: 5, slidesPerView: 5 },
            992: { slidesPerGroup: 6, slidesPerView: 6 },
            1200: { slidesPerGroup: 7, slidesPerView: 7, spaceBetween: 12 },
            1400: { slidesPerGroup: 8, slidesPerView: 8, spaceBetween: 16 },
            1600: { slidesPerGroup: 10, slidesPerView: 10 },
          },
        }}
        items={data.slice(0, 18)}
        swiperName={"tv-channels"}
      >
        {(broadcast) => (
          <TvCard
            key={broadcast.id}
            title={broadcast.title}
            id={broadcast.id}
            quality={broadcast.quality}
            is_free={broadcast.is_free}
            icon={broadcast.icon}
            animation={false}
          />
        )}
      </Carousel>
    </Section>
  );
};

export default MainTvSection;
